import { useHotels } from "contexts/HotelsSearchContext/HotelProvider";
import type { Room } from "../type";
import type { Root as RootProfile } from "services/get-profile";
import { FaWallet } from "react-icons/fa6";

type Props = {
  rooms: Room[];
  handleRoomSelected: (room: Room) => void;
  profile: RootProfile;
};

export const ListingStayDetailRooms = ({
  handleRoomSelected,
  rooms,
  profile,
}: Props) => {
  const { isBooking } = useHotels();

  const price = (room: Room) => {
    if (profile.wallet.balance === 0) {
      return (
        <span className="text-sm font-medium">
          Você não tem <br />
          ViroCash disponível
        </span>
      );
    }

    return (
      <p className="flex items-center whitespace-nowrap font-medium text-neutral-800 dark:text-neutral-200">
        <FaWallet className="mr-1 -mt-[1px]" size={18} />
        {new Intl.NumberFormat("pt-BR").format(room.price)} ViroCash
      </p>
    );
  };

  return (
    <div className="listingSection__wrap lg:p-5">
      <h2 className="text-2xl font-semibold mb-0">Escolha seu Quarto</h2>
      <div className="grid grid-cols-1 gap-4 mt-4">
        {rooms.map((room, index) => {
          return (
            <div
              key={room.id}
              className="flex items-center border-neutral-200 dark:border-neutral-700 border p-4 rounded-lg"
            >
              <div className="w-full">
                <p className="block mb-4 text-lg dark:text-neutral-300 font-semibold">
                  {room.description}
                </p>
                <p className="block mb-4 text-sm dark:text-neutral-400">
                  Quarto oferece:{" "}
                  <span className="font-semibold">
                    {room.board_description}
                  </span>
                </p>

                <p className="mt-4 font-medium text-neutral-800 dark:text-neutral-200">
                  Quantidade disponíveis de quartos: {room.quantity_available}
                </p>

                <div className="flex mt-4 gap-5 md:items-center flex-col md:flex-row">
                  {price(room)}
                  <p>
                    {profile.wallet.balance > 0 ? (rooms && room.cashback.value > 0) && (<span className="text-sm whitespace-nowrap font-normal italic text-[#F97316]">
                      Ganhe <strong>{`${room.cashback.value} ViroCash`}</strong> de volta!
                    </span>): null}
                  </p>
                </div>
              </div>

              <div className="h-1/2 mx-5 w-[1px] bg-neutral-100 dark:bg-neutral-6000"></div>

              <div>
                <input
                  defaultChecked={index === 0}
                  id={`room-radio-${room.id}`}
                  value={room.id}
                  name="input-radio-room"
                  onChange={() => handleRoomSelected(room)}
                  type="radio"
                  disabled={isBooking}
                  className="focus:ring-blue h-6 w-6 text-blue border-neutral-300 dark:border-neutral-6000 !checked:bg-primary-500 bg-transparent cursor-pointer hover:border hover:border-neutral-300"
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
